// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".streamsvueinput.vue-tags-input{margin:5px 0;max-width:none;width:100%}", "",{"version":3,"sources":["webpack://./resources/assets/js/partials/Admin/CustomerStreamDetails.vue"],"names":[],"mappings":"AAAA,gCAAA,YAAA,CAAA,cAAA,CAAA,UAAA","sourcesContent":[".streamsvueinput.vue-tags-input{max-width:none;width:100%;margin:5px 0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
